export default "__VITE_ASSET__v6iQLk3$__"